import { createFileRoute } from '@tanstack/react-router'
import { CompareIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/vergleich/')({
  loader: () => loadPageData({ data: { kind: 'compare', locale: 'de' } }),
  head: () => staticRouteHead('compare', 'de'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CompareIndexPage />
    </CatalogProvider>
  )
}
